export const LOOKING_FOR_OPTIONS = [
  "Networking",
  "Cofounder",
  "Investor",
  "Mentor",
  "Freelancer",
  "Others"
];